import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { Box } from '@material-ui/core';
import {
  ContentState, convertFromHTML, convertFromRaw, EditorState, convertToRaw,
} from 'draft-js';
import Stepper from './Stepper';
import urls from '../../../../constants/urls';
import MainBody from '../../../../components/templates/mainBody/MainBody';
import BasicBreadcrumbs from '../../../../components/organisms/basicBreadcrumbs/BasicBreadcrumbs';
import BaseInfo from './BaseInfo';
import Condition from './Condition';
import Content from './Content';
import { createForm, createFormFromProps, errorMessageForm } from './entry-proc';
import {
  actCallInitMailMagazineEntry,
  actCallMailMagazineEntryMembers,
  actResetMailMagazineMembers,
} from '../../../../redux/setting/mailMagazineEntry/action';
import {
  actCallUpdateMailMagazineDetail,
} from '../../../../redux/setting/mailMagazineDetail/action';
import validation from './validation';

const STEPS = [
  { id: 0, label: '基本情報設定' },
  { id: 1, label: '送信条件設定' },
  { id: 2, label: '送信内容設定' },
];

class MailMagazineEntry extends React.Component {
  constructor(props) {
    super(props);
    this.breadcrumbs = [
      { url: urls.SETTING.MAIL_MAGAZINE, name: 'メールマガジン一覧' },
      { name: 'メール基本情報作成' },
    ];

    const selects = {
      stores: [],
      contractProductTypes: [],
      ages: [],
      status: [],
    };

    let isMain = false;
    let store = null;
    if (props.common.user) {
      isMain = props.common.user.main;
      store = props.common.user.store;
    }

    this.state = {
      data: this.props.data
        ? createFormFromProps(this.props.data, this.toEditState)
        : createForm(store),
      errorMessage: errorMessageForm(),
      activeStep: 0,
      selects,
      members: [],
      templates: [],
      isMain,
    };

    this.scrollToTop();
  }

  componentDidMount() {
    this.props.dispatch(actCallInitMailMagazineEntry());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mailMagazineEntry.selects !== this.props.mailMagazineEntry.selects) {
      if (this.props.mailMagazineEntry.selects) {
        this.setSelectValues(this.props.mailMagazineEntry.selects);
      }
    }
    if (prevProps.mailMagazineEntry.members !== this.props.mailMagazineEntry.members) {
      if (this.props.mailMagazineEntry.members) {
        this.setState({ members: this.props.mailMagazineEntry.members });
      }
    }
    if (prevProps.mailMagazineEntry.templates !== this.props.mailMagazineEntry.templates) {
      if (this.props.mailMagazineEntry.templates) {
        this.setState({ templates: this.props.mailMagazineEntry.templates });
      }
    }
    if (prevProps.mailMagazineDetail.isUpdateSuccess
        !== this.props.mailMagazineDetail.isUpdateSuccess) {
      if (this.props.mailMagazineDetail.isUpdateSuccess) {
        this.props.history.push({
          pathname: urls.SETTING.MAIL_MAGAZINE_DETAIL,
          state: {
            detailId: this.props.mailMagazineDetail.detailId,
          },
        });
      }
    }
  }

  setSelectValues = (selects) => {
    this.setState({ selects });
  }

  scrollToTop = () => window.scrollTo(0, 0);

  handleChange = (event, type) => {
    const { name, value } = event.target;
    const { data } = this.state;
    const entryData = {
      ...data[type],
      [name]: value,
    };
    const newData = {
      ...data,
      [type]: entryData,
    };
    this.setState({ data: newData });

    if (type === 'condition') {
      this.props.dispatch(actResetMailMagazineMembers());
    }
  }

  validateInput = (type) => {
    const { data } = this.state;
    const entryData = data[type];
    let tempError = errorMessageForm()[type];

    Object.keys(entryData).forEach((key) => {
      tempError = {
        ...tempError,
        [key]: validation.formValidate(key, entryData[key]),
      };
    });

    if (validation.validateSendAt(data.baseInfo)) {
      tempError.sendAt = '日付と時間の両方を入力してください';
    }

    const { errorMessage: error } = this.state;
    const newError = {
      ...error,
      [type]: tempError,
    };

    this.setState({ errorMessage: newError });
    return Object.values(tempError).every((v) => v === '');
  };

  handleChangeStep = (type, activeStep) => {
    const { activeStep: currentStep } = this.state;
    if (currentStep < activeStep) {
      if (!this.validateInput(type)) return;
    }

    this.setState({ activeStep });
    this.scrollToTop();
  }

  handleSelectTemplate = (value) => {
    const { data } = this.state;
    const baseInfo = {
      ...data.baseInfo,
      mstMailTemplate: value,
    };
    const content = {
      body: this.toEditState(value.content),
      subject: value.subject,
    };
    const newData = {
      ...data,
      baseInfo,
      content,
    };
    this.setState({ data: newData });
  }

  isJson = (str) => {
    if (typeof str !== 'string') return false;

    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  toEditState = (rawState) => {
    const blocksFromHTML = convertFromHTML(rawState);
    const contentState = this.isJson(rawState)
      ? convertFromRaw(JSON.parse(rawState))
      : ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap,
      );
    return EditorState.createWithContent(contentState);
  }

  handleSearch = () => {
    const { data } = this.state;
    const searchCondition = {
      ...data.condition,
      ageId: data.condition.age ? data.condition.age.id : null,
      mstStoreId: data.baseInfo.mstStore.id,
      contractProductType: data.condition.contractProductType
        ? data.condition.contractProductType.id
        : null,
    };
    this.props.dispatch(actCallMailMagazineEntryMembers(searchCondition));
  }

  handleSave = (type) => {
    if (!this.validateInput(type)) return;
    const { data } = this.state;
    const payload = {
      id: data.id,
      mstStoreId: data.baseInfo.mstStore.id,
      title: data.baseInfo.title,
      statusId: data.baseInfo.status ? data.baseInfo.status.id : null,
      genderId: data.condition.gender,
      ageId: data.condition.age ? data.condition.age.id : null,
      memberNo: data.condition.memberNo,
      contractProductType: data.condition.contractProductType
        ? data.condition.contractProductType.id : null,
      sendDate: data.baseInfo.sendDate ? data.baseInfo.sendDate.replaceAll('-', '/') : null,
      sendHour: data.baseInfo.sendHour ? data.baseInfo.sendHour.id : null,
      subject: data.content.subject,
      body: this.toRowState(data.content.body),
    };
    if (this.props.fromDetail) {
      this.props.onSaveDetail(payload);
      return;
    }
    this.props.dispatch(actCallUpdateMailMagazineDetail(payload));
  }

  toRowState = (editState) => {
    const draftContent = convertToRaw(editState.getCurrentContent());
    return JSON.stringify(draftContent);
  }

  targetStep = () => {
    const { target } = this.props;
    const { activeStep } = this.state;
    return target ?? activeStep;
  }

  render() {
    const {
      fromDetail,
    } = this.props;

    const {
      activeStep,
      selects,
      members,
      data,
      templates,
      errorMessage,
      isMain,
    } = this.state;

    return (
      <div>
        {!fromDetail && (
          <BasicBreadcrumbs breadcrumbs={this.breadcrumbs} />
        )}
        <MainBody>
          {!fromDetail && (
          <Stepper
            steps={STEPS}
            activeStep={activeStep}
          />
          )}

          <Box display={this.targetStep() === 0 ? '' : 'none'}>
            <BaseInfo
              type="baseInfo"
              isMain={isMain}
              onChange={this.handleChange}
              activeStep={activeStep}
              data={data.baseInfo}
              templates={templates}
              errorMessage={errorMessage.baseInfo}
              onChangeStep={this.handleChangeStep}
              onSelectTemplate={this.handleSelectTemplate}
              initSelectValues={selects}
              onSave={this.handleSave}
              fromDetail={fromDetail}
            />
          </Box>

          <Box display={this.targetStep() === 1 ? '' : 'none'}>
            <Condition
              type="condition"
              activeStep={activeStep}
              store={data.baseInfo.store}
              onChange={this.handleChange}
              data={data.condition}
              errorMessage={errorMessage.baseInfo}
              onChangeStep={this.handleChangeStep}
              initSelectValues={selects}
              members={members}
              onSearch={this.handleSearch}
              onSave={this.handleSave}
              fromDetail={fromDetail}
            />
          </Box>

          <Box display={this.targetStep() === 2 ? '' : 'none'}>
            <Content
              type="content"
              activeStep={activeStep}
              onChange={this.handleChange}
              data={data.content}
              errorMessage={errorMessage.content}
              onChangeStep={this.handleChangeStep}
              onSave={this.handleSave}
              fromDetail={fromDetail}
            />
          </Box>
        </MainBody>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mailMagazineEntry: state.mailMagazineEntry,
  mailMagazineDetail: state.mailMagazineDetail,
  common: state.common,
});

export default withRouter(connect(mapStateToProps)(MailMagazineEntry));
